import React, { useRef } from "react";
import Header from "../../header.js";
import Footer from "../../footer.js";
import StreamDisplay from "../../streamDisplay.jsx";
import { videoList } from "../../VideoResults/videoResultsFlowGlow.js";

const resultsArr = videoList.Riona;

class Riona extends React.Component{
    render(){
    
      return(
            <div id="wrapper">

        {/* Header */}
        <Header />

        {/* Menu */}

        {/* Main */}
                <StreamDisplay talentName="Isaki Riona" results={resultsArr} />


        {/* Footer */}
            <Footer />

    </div>
    )
}
}

export default Riona